<template>
  <div>
    <div class="loading-container" v-if="isLoading">
      <div class="loading">
        <p>
          LOADING
          <br />
          <Center>
            <i style="font-size: 3em" class="el-icon-loading" />
          </Center>
        </p>
      </div>
    </div>

    <ElRow id="header" :gutter="24">
      <ElCol :span="24">
        <h1>Module Editor</h1>
        <div id="headerborder" />
      </ElCol>
    </ElRow>

    <RouterView />

    <div v-if="showIndex">
      <ElRow :gutter="24">
        <ElCol :span="24">
          <ul>
            <li :key="k" v-for="(m, k) in modules">
              <h3>
                <RouterLink
                  class="editlink"
                  :to="{ name: 'modeditormod', params: { mod: m.slug } }"
                >
                  {{ m.name }}&nbsp;
                  <i class="fa fa-edit" />
                </RouterLink>
              </h3>
            </li>
          </ul>
        </ElCol>
      </ElRow>
    </div>
  </div>
</template>
<script>
export default {
  name: "ModEditorIndex",
  watch: {
    // hide the menu when there is a child rendered in the routerview
    $route() {
      if (this.$route.params.mod) {
        this.showIndex = false
      }
    }
  },
  mounted() {
    this.isLoading = true
    // get the index data
    this.$API.get("/admin/modules-index").then(r => {
      this.modules = r.data
      this.isLoading = false
    })
  },

  data() {
    return {
      showIndex: true,
      modules: [],
      isLoading: false
    }
  }
}
</script>
<style lang="scss" scoped>
.routerlink {
  color: #0ae;
  padding: 0.2em;
}

.routerlink:hover {
  color: white;
  background-color: #0ae;
  padding: 0.2em;
  border-radius: 10px;
}
.editlink {
  font-family: "Roboto";
  font-size: 1.2em;
  font-weight: 700;
}

.editlink:hover {
  color: #00aaee;
}

label {
  font-family: "Montserrat";
  font-size: 0.9rem;
  font-weight: bold;
  color: rgba(68, 68, 68, 0.8);
  // border-top: 1px solid black;
}

div.loading-container {
  position: absolute;
  opacity: 0.7;
  top: 0;
  left: 0;
  background-color: #eee;
  width: 100%;
  position: absolute;
  height: 100%;
  z-index: 100;
}

div.loading {
  height: 30em;
  margin: 0 auto;
  z-index: 9999;
}

div.loading p {
  position: relative;
  color: white;
  border-radius: 4px;
  padding: 1em;
  margin: 0;
  background-color: #00aaee;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2),
    0px 12px 17px 2px rgba(0, 0, 0, 0.137255),
    0px 5px 22px 4px rgba(0, 0, 0, 0.117647);
  z-index: 9999;
}

#headerborder,
#headerborder > a {
  color: white;
  padding: 2px;
  font-family: "Roboto";
  background-color: #0ae;
}

#header {
  margin-bottom: 1em;
}
</style>
